// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1wRa4","ranges":"BmiRanges_ranges__kSXoa"};